export default getExportBlock;

function getExportBlock(entry) {
	var name = entry.identifierReplacements["default"];
	return "exports['default'] = " + name + ";";
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/builders/strictMode/utils/getExportBlock.js.01-babel.map